import url from 'url';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import path from 'path';

export default {
  methods: {
    getFileWithCDN(fileURL, params = {}, prefix = 'static')  {
      if (isEmpty(this.$config.aws_cloudfront_url)) {
        return fileURL;
      }

      const imageExt = [
        'jpg',
        'jpeg',
        'webp',
        'png',
        'svg',
        'gif'
      ];

      const query = cloneDeep(params);
      if (imageExt.includes(this.getFileExtension(fileURL))) {
        query.quality = 85;
      }

      return url.format({
        pathname: new URL(path.join(prefix, fileURL), this.$config.aws_cloudfront_url).toString(),
        query
      })
    },
    getFileExtension(url) {
      return url.split('.').pop().split(/[#?]/)[0];
    }
  }
}
